import { Subject } from 'rxjs';

export const toolStarted = new Subject<void>();
